module.exports = "/build/images/minusButtonActive.svg?ea86c20451b533d3e6a94751f26e48b1";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/minusButtonActive.svg
// module id = 539
// module chunks = 0